export default [
  {
    path: "/key-guidance",
    props: true,
    component: () => import("../KeyGuidance.vue")
  }
]
